export class APIs {
  // Identity

  public static Identity = {
    LoginUaePass: 'Identity/api/UaePass/get-auth-code-url',
    GetLoginToken: 'Identity/api/UaePass/login',
    LogoutUaePass: 'Identity/api/UaePass/get-logout-url',
    RefreshToken: 'Identity/api/Identity/RefreshToken',
    RegisterUaePass: 'Identity/api/UaePass/get-auth-register-code-url',
    postConfirm: 'Identity/api/UaePass/confirm-register',
    SendOtp: 'Identity/api/Identity/Login/Portal',
    VerifyOtp: 'Identity/api/Identity/validate-sms-otp',
    LoginWithPassword: 'Identity/api/Identity/validate-non-uae-password',
    // Registration APIs
    InitiateRegistration: 'Identity/api/Registration/initiate',
    ValidateSmsOtp: 'Identity/api/Registration/validate-sms-otp',
    ValidateEmailOtp: 'Identity/api/Registration/validate-email-otp',
    ResendOtpSms: 'Identity/api/Registration/resend-otp-sms',
    ResendOtpEmail: 'Identity/api/Registration/resend-otp-email',
    SetPasswordAndLogin: 'Identity/api/Registration/set-user-password',
    GetNationalitiesLookups:
      'Identity/api/Registration/get-nationalities-lookups',
    ForgotPassword: 'Identity/api/Identity/forgot-password',
    ResetPassword: 'Identity/api/Identity/reset-password',
  };

  // Translation
  public static Translation = {
    Get: '/Utilities/api/CMS/Resource/Get',
    GetUnAuth: '/Utilities/api/CMS/Resource/GetUnAuthorizedResources',
    Set: '/Utilities/api/CMS/Resource/Set',
    createTranslation: '/Utilities/api/Translator/Translate',
  };
  // Translation
  public static Complaint = {
    GetList: 'Complaints/GetList',
    Create: 'HHEO/api/Complaints/Create',
    GetLockups: 'HHEO/api/Complaints/GetLookups',
  };

  public static Home = {
    SliderData: 'Utilities/api/public/press-releases/list/latest/10',
    GetCategories: 'HHEO/api/Organization/Categories/Get',
    GetServices: 'HHEO/api/Service/Get',
    GetTargetAudiences: '/HHEO/api/Lookup/Get/TargetAudience',
    GetServiceTypes: '/HHEO/api/Lookup/Get/ServiceType',
    GetOrganizationsList: '/HHEO/api/Organization/GetList',
    GetOrganizationsListSpecific: '/HHEO/api/Organization/by-internal-services',
    GetStatusList: '/HHEO/api/Lookup/ExternalRequestStatus',
    GetEventCalender: 'EventService/api/public/event/filter-with-month',
  };

  public static Contact = {
    Categories: 'HHEO/api/Organization/Categories/Get',
    CategoryById: 'HHEO/api/Organization/GetByCategoryId',
    SubmitInquiry: 'Utilities/api/public/general-questions/submit-inquiry',
    MapData: 'Utilities/api/public/setting/map',
  };
  public static Service = {
    ServiceById: 'HHEO/api/Service/GetDetails',
    GetBookingDetailsAppointments: 'HHEO/api/my/requests/appointments/',
    ApproveAppointments: 'HHEO/api/my/requests/appointments/confirm',
    RejectAppointments: 'HHEO/api/my/requests/appointments/reject',
    RequestRating: 'HHEO/api/my/requests/rate/',
    SubmitRequestRating: 'HHEO/api/my/requests/rate/submit',
    bankAccounts: 'HHEO/api/lookup/bank-accounts',
    RequestCriteriasRating: 'HHEO/api/service/request/criterias/',
    SubmitRequestCriteriasRating: 'HHEO/api/service/request/submit-rate',
    ViewTrack: 'HHEO/api/public/ActivityTracking/',
    Track: 'HHEO/api/ActivityTracking/',
    ExternalService: 'HHEO/api/public/ActivityTracking/',
  };

  public static Suggestion = {
    GetLockups: '/HHEO/api/Suggestion/Get/Lookup',
    Create: '/HHEO/api/Suggestion/Create',
    CheckJobNumber: '/HHEO/api/Suggestion/check-job-number',
  };
  public static Profile = {
    ProfileById: 'UserManagement/api/Profile/Get',
    GetUserRequests: 'HHEO/api/Service/Request/Get',
    GetUserSuggestions: 'HHEO/api/my/suggestions',
    GetUserComplaints: 'HHEO/api/my/complaints',
    GetUserComplaintById: 'HHEO/api/my/complaints/',
    GetUserSuggestionsById: 'HHEO/api/my/suggestions/',
    GetUserRequestById: 'HHEO/api/my/requests/',
    CreateRequest: 'HHEO/api/Service/Request/Create',
    getLookUp: 'HHEO/api/Service/',
    GetRequestDetails: 'HHEO/api/my/requests/',
    UpdateRequest: 'HHEO/api/my/requests/',
    AccountDetails: 'HHEO/api/service/request/get-account-details',
  };

  public static UploadAttachment = {
    Upload: 'FileService/api/File/upload',
    UploadToBlob: 'FileService/api/File/upload-to-blob',
  };
  public static Loyalty = {
    statistics: 'LpBackend/api/platform/user-activities/statistics',
    UserActivity: 'LpBackend/api/platform/user-activities',
    UserActivityAcceptPeriod:
      'LpBackend/api/platform/user-activities/Grace-period',

    ActivityTypes: 'LpBackend/api/platform/activity-types',
    UserActivityDetails: 'LpBackend/api/platform/user-activities/details/',
    Gifts: 'LpBackend/api/platform/gifts/organization/',
    memberShip: 'LpBackend/api/platform/Membership',
    orgCenters: 'LpBackend/api/platform/organization-centers/',
    organizationByUser: 'LpBackend/api/platform/organizations-by-userId/',
    membershipWithGracePeriod:
      'LpBackend/api/platform/membership-with-grace-period',
    GiftTypes: 'LpBackend/api/platform/gift-types',
    CartItem: 'LpBackend/api/platform/cart-items',
    CreateOrder: 'LpBackend/api/platform/order',
    orders: 'LpBackend/api/platform/orders',
    rejectItem: 'LpBackend/api/platform/orderitem/status',

    getCartItemsCount: 'LpBackend/api/platform/cart-items/count/organization/',
    guardianApproval: 'LpBackend/api/platform/orders/guardian-approval',
    guardianRequests: 'LpBackend/api/platform/guardian-requests',
    organizationsByGuardianId:
      'LpBackend/api/platform/organizations-by-guardian-id',
    getCartItems: 'LpBackend/api/platform/cart-items/organization/',
    OrganizationCentersNearby: 'LpBackend/api/OrganizationCenters/nearby',
  };

  public static Files = {
    GetFiles: 'FileService/api/File/GetFiles',
  };
  public static Events = {
    GetEventsWithFilter: 'eventservice/api/public/event/filter',
    FilterEventsWithMonth: 'eventservice/api/public/event/filter-with-month',
    GetCategories: 'eventservice/api/public/event/categories',
    GetEventDetails: 'EventService/api/public/event/details/',
    GetEventRegisterationDetails: 'eventservice/api/event/details/',
    RegisterEvent: 'eventservice/api/event/register',
    AttendeeRating: 'eventservice/api/Attendee/Rating',
    GetUserEvents: 'EventService/api/my/attendees',
    GetEventTypes: 'eventservice/api/Lookup/event-lookups',
    // RegisteredEvent: 'EventService/api/Attendee/GetRegisterationDetails'
    RegisteredEvent: 'EventService/api/my/attendees',
    CancelRegistration: 'EventService/api/Attendee/Cancel',
    AttachmentsRegisteredEvent: 'FileService/api/File/GetFile/',
    UpdateRegistration: 'EventService/api/Attendee/re-submit',
    RegisterEventStatus: 'EventService/api/Lookup/attendee-status',
    GetInvoice: 'EventService/api/payment/event/invoice/',
    GetEventCertificateRegistered: 'EventService/api/Certificate/registration-html',
    GetEventCertificateAttended: 'EventService/api/public/Certificate/certificate-html',
  };

  public static Rating = {
    PostRating: 'EventService/api/Attendee/Rating',
  };

  public static Utilities = {
    AboutUs: 'Utilities/api/public/cms/page/HHEOPortal:AboutUs',
    SpeechOfHerHighness:
      'Utilities/api/public/cms/page/HHEOPortal:SpeechOfHerHighness',
    BiographyofHerHighnessSheikha:
      'Utilities/api/public/cms/page/HHEOPortal:BiographyofHerHighnessSheikha',
    Categories: 'Utilities/api/public/cms/page/HHEOPortal:Quotes',
    Achievement: 'Utilities/api/public/cms/page/HHEOPortal:Achievements',
    Quotes: 'Utilities/api/public/cms/page/HHEOPortal:Quotes',
    ChildrenAndYouthEntity:
      'Utilities/api/public/cms/page/HHEOPortal:ChildrenAndYouthEntity',
    FamilyEntity: 'Utilities/api/public/cms/page/HHEOPortal:FamilyEntity',
    WomenEmpowermentEntity:
      'Utilities/api/public/cms/page/HHEOPortal:WomenEmpowermentEntity',
    CharityAndGivingEntity:
      'Utilities/api/public/cms/page/HHEOPortal:CharityAndGivingEntity',
    TestList: 'Utilities/api/public/cms/page/HHEOPortal:TestList',
    TestPage: 'Utilities/api/public/cms/page/HHEOPortal:TestPage',
    GetChildrenByParentId: 'Utilities/api/public/cms/elements-by-parent-id',
    editItem: 'Utilities/api/cms/page-element/set',
    organization: 'Utilities/api/public/cms/page/',
    awardsAndAchievements:
      'Utilities/api/public/cms/page/HHEOPortal:Achievement',
    addItem: 'Utilities/api/cms/page-element/add-list-item',
    deleteItem: 'Utilities/api/cms/page-element/delete',
  };
  public static Jobs = {
    GetJobsWithFilter: 'CareersAndVolunteers/api/public/careers/jobs/list',
    GetJobDetails: 'CareersAndVolunteers/api/public/careers/jobs/details',
    GetDegreeLookUps: 'CareersAndVolunteers/api/careers/lookups/degree-type',
    GetProficiencyLevelLookUps:
      'CareersAndVolunteers/api/careers/lookups/proficiency-level',
    GetSkillLookUps: 'CareersAndVolunteers/api/careers/lookups/skill',
    ApplyInJob: 'CareersAndVolunteers/api/careers/jobs/apply',
    UpdateApplication:
      'CareersAndVolunteers/api/careers/jobs/applications/update',
    GetJobTypeLookUps:
      'CareersAndVolunteers/api/public/careers/lookups/job-type',
    GetWorkEnvLookUps:
      'CareersAndVolunteers/api/careers/lookups/work-environment',
    GetJobsLookups: 'CareersAndVolunteers/api/admin/careers/jobs/lookups',
    GetExperienceLevelLookUp:
      'CareersAndVolunteers/api/public/careers/lookups/experience-level',
    GetCurrencyLookUp:
      'CareersAndVolunteers/api/public/careers/lookups/currency',
    GetJobsQuestions: 'CareersAndVolunteers/api/careers/jobs/questions/',
    GetUserJobs: 'CareersAndVolunteers/api/my/job-applications',
    GetMaxSalary:
      'CareersAndVolunteers/api/public/careers/lookups/salary-range',
    RegisterJobStatus: 'CareersAndVolunteers/api/careers/lookups/job-status',
    JobApplicationStatus:
      'CareersAndVolunteers/api/careers/lookups/job-application-status',
    GetMaritalStatusLookUps:
      'CareersAndVolunteers/api/careers/lookups/job-application-marital-status',
  };
  public static Volunteers = {
    GetVolunteersWithFilter: 'CareersAndVolunteers/api/public/volunteers/list',
    GetVolunteerStatus:
      'CareersAndVolunteers/api/volunteers/lookups/volunteer-status',
    GetVolunteerDetails: 'CareersAndVolunteers/api/public/volunteers/details',
    ApplyInVolunteer: 'CareersAndVolunteers/api/volunteers/apply',
    UpdateApplication:
      'CareersAndVolunteers/api/volunteers/applications/update',
    RegisterVolunteerStatus: 'api/volunteers/lookups/volunteer-status',
    VolunteerApplicationStatus:
      'CareersAndVolunteers/api/volunteers/lookups/volunteer-application-status',
    GetVolunteersQuestions: 'CareersAndVolunteers/api/volunteers/questions/',
    GetUserVolunteers: 'CareersAndVolunteers/api/my/volunteer-applications',
    GetVolunteersCertificateRegistered: 'CareersAndVolunteers/api/Certificate/registration-volunteer-html',
    GetVolunteersCertificateFit: 'CareersAndVolunteers/api/public/Certificate/fit-application-html',

  };

  public static Memberships = {
    GetMemberships: 'Membership/api/public/memberships/packages/list',
    GetMyMemberships: 'Membership/api/my/memberships',
    GetMyApplication: 'Membership/api/my/application/',
    GetMyMembershipDetails: 'Membership/api/my/memberships/packages/',
    GetDurationlookups: 'Membership/api/public/lookups/durations',
    GetPackageTypelookups: 'Membership/api/public/lookups/package-type',
    //GetPackageDetails: 'Membership/api/public/memberships/packages/details',
    GetPackageDetails: 'Membership/api/public/memberships/packages/details/',
    GetPaymentDetails: 'Payment/api/Payment/details/',
    GetRequestDetails: 'Membership/api/my/requests/',
    GetApplicationFormFields: 'Membership/api/memberships/packages/fields/',
    PackageApply: 'Membership/api/memberships/packages/apply',
    GetStatusStatus: 'Membership/api/public/lookups/memberShip-status',
    GetMyMemberShipList: 'Membership/api/my/requests',
    GetMyActiveMemberShipList: 'Membership/api/my/requests/active',
    GetDraftApplicationFormFields: (id: string): string =>
      `Membership/api/my/requests/${id}/application-data`,
    PostDraftApplication: 'Membership/api/memberships/requests/update',
    CancelRequest: 'Membership/api/memberships/requests/cancel',
    GetInvoice: 'Membership/api/payment/membership/invoice/',
    GetTransferMembership: 'Membership/api/members/transfer/request-details/',
    ApproveTransferMembership: 'Membership/api/members/transfer/approve',
    RejectTransferMembership: 'Membership/api/members/transfer/reject',
    GetUserPhoto: 'Membership/api/memberships/requests/user/photo',
    ViewTrack: 'Membership/api/public/memberships/ActivityTracking/',
    Track: 'Membership/api/memberships/ActivityTracking/',
    ExternalService: 'Membership/api/public/memberships/ActivityTracking/',
    GetMemberShipCertificate: 'Membership/api/Certificate/membership-request-approved-html',
  };

  public static Bookings = {
    BookingsList: 'Booking/api/public/assets/list',
    SubmitBooking: 'Booking/api/assets/submit',
    LookUps: 'Booking/api/booking/lookups',
    MyBookingsLookUps: 'Booking/api/lookups',
    MyBookingsList: 'Booking/my/bookings',
    MyBookingDetails: 'Booking/my/bookings/',
    getBookingDetails: 'Booking/api/public/assets/details/',
    cancelBooking: 'Booking/api/booking/cancel',
    updateBooking: 'Booking/api/booking/update',
    BookingsAssetTypes: 'Booking/api/public/lookups/asset-types',
    BookingsAssetCapacityRanges:
      'Booking/api/public/lookups/asset-capacity-ranges',
    BookingTargetAudiences: 'Booking/api/lookups/target-audiences',
    GetInvoice: 'Booking/api/payment/booking/invoice/',
    ViewTrack: 'Booking/api/public/ActivityTracking/',
    Track: 'Booking/api/public/ActivityTracking/',
    ExternalService: 'Booking/api/public/ActivityTracking/',
  };

  public static Competitions = {
    GetCompetitions: 'Competitions/api/public/competitions/list',
    GetNewCompetitions:
      'Competitions/api/public/SheikhSultanCompetition/GetAllCompetitions',
    GetCompetitionDetails: 'Competitions/api/public/competitions/details/',
    GetNewCompetitionDetails:
      'Competitions/api/public/SheikhSultanCompetition/GetDetails/',
    GetUserCompetitions: 'Competitions/my/competitions',
    GetCompetitionsStatus: 'Competitions/api/public/lookups/competition-status',
    GetCompetitionApplicationStatus:
      'Competitions/api/public/lookups/application-status',
    GetCompetition: 'Competitions/api/public/competitions/details/',
    GetCompetitionSkills: 'Competitions/api/public/lookups/skills',
    CompetitionApply: 'Competitions/api/Competitions/apply',
    CompetitionType: 'Competitions/api/public/lookups/competition-type',
    MyCompetitionDetails: 'Competitions/my/competitions/',
    GetMyInvitations: '/Competitions/api/my/ceremony-invites/GetMyInvites',
    RespondToInvitation: '/Competitions/api/my/ceremony-invites/Respond',
    GetMyInvitation:
      '/Competitions/api/my/ceremony-invites/GetInvitationDetails',
    RespondToRating: '/Competitions/api/my/ceremony-invites/Rating',
    GetCompetitionsCertificate: 'Competitions/api/Certificate/competition-registration-html/',
    GetCompetitionsCertificateWinner: 'Competitions/api/Certificate/competition-winner-html/',
    WizardGetMyApplications: '/Competitions/api/wizard/GetMyApplications',
    WizardGetMyApplicationsDetails: '/Competitions/api/wizard/GetMyApplicationsDetails',
    WizardSaveRegistration: '/Competitions/api/wizard/SaveRegistration',
    WizardSaveRegistrationOption: '/Competitions/api/wizard/SaveRegistrationOption',
    WizardSaveThirdCategory: '/Competitions/api/wizard/SaveThirdCategory',
    WizardSaveExtras: '/Competitions/api/wizard/SaveExtras',
    WizardSubmit: '/Competitions/api/wizard/submit',
    WizardGetDraftApplication: '/Competitions/api/wizard/GetMyDraftApplicationAsync',
    LookupsGetSchools: '/Competitions/api/SheikhSultanAwardLookups/GetSchools',
    LookupsGetOrganizations: '/Competitions/api/SheikhSultanAwardLookups/GetOrganizations',
    GetCoordinators: '/Competitions/api/organization-coordinator/GetSheikhSultanCoordinators',
  };

  public static MediaCenter = {
    AlbumDetails: 'Utilities/api/public/media-center/albums/details',
    NewsDetails: 'Utilities/api/public/press-releases/details',
    albumsList: 'Utilities/api/public/media-center/albums/list',
    albumsCategories:
      'Utilities/api/public/media-center/albums/categories/list',
    videosList: 'Utilities/api/public/media-center/videos/list',
    videosCategories:
      'Utilities/api/public/media-center/videos/categories/list',
    pressList: 'Utilities/api/public/press-releases/list',
    pressCategories: 'Utilities/api/public/press-releases/categories/list',
  };
  public static UserManagement = {
    SoftDelete: '/UserManagement/api/User/SoftDelete',
  };

  public static Survey = {
    Submit: 'Utilities/api/public/Surveys/submit',
    GetConfiguration: 'Utilities/api/public/satisfaction-configurations',
  };

  public static MessageTemplates = {
    GetByTitle: 'Utilities/api/public/message-templates/by-title',
  };

  public static ShareActivityLog = {
    Create: 'Utilities/api/share-activity-log/create',
  };

  public static Notifications = {
    SendImmediateEmail: 'Utilities/api/Notification/SendImmediateEmail',
    SendEventSharingEmail: 'Utilities/api/Notification/SendEventSharingEmail',
  };
}
